import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<g stroke="none"><path fill-rule="evenodd" d="M11 6h2a1 1 0 0 0 0-2H9a1 1 0 0 0 0 2v2a1 1 0 0 0-1 1v1c0 .029.002.058.004.086a2 2 0 0 0-1.417 1.83l-.543 13.042A1 1 0 0 0 7.043 26h5.915a1 1 0 0 0 1-1.042l-.544-13.041a2 2 0 0 0-1.417-1.831c.002-.028.004-.057.004-.086V9a1 1 0 0 0-1-1V6zm-2.414 6-.5 12h3.83l-.5-12h-2.83z" clip-rule="evenodd"></path><path fill-rule="evenodd" d="M18 9.535V7a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2.535c1.196.692 2 1.984 2 3.465v12a1 1 0 0 1-1 1h-8a1 1 0 0 1-1-1V13c0-1.48.805-2.773 2-3.465zM20 9V8h2v1h-2zm0 2a2 2 0 0 0-2 2v11h6V13a2 2 0 0 0-2-2h-2z" clip-rule="evenodd"></path></g>';
export var BeautyProductsOutlineSVG = function BeautyProductsOutlineSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
BeautyProductsOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(BeautyProductsOutlineSVG);